export default !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/~/dom-helpers/esm/canUseDOM.js
// module id = 1092
// module chunks = 4